'use strict';

var $isNaN = require('../helpers/isNaN');

// https://ecma-international.org/ecma-262/6.0/#sec-samevaluezero

module.exports = function SameValueZero(x, y) {
	return (x === y) || ($isNaN(x) && $isNaN(y));
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-abstract/2020/SameValueZero.js
 ** module id = 2917
 ** module chunks = 0
 **/